module.exports = __webpack_public_path__ + "img/undraw_Social_life_re_x7t5.ff3f740e.svg";